import { sort, Order, ColumnType } from './sortBy';
import { IEmailTemplateWithProductId } from '../constants/visits.constant';
import { ALTERNATE_RX_PRODUCT_VALUE } from '../constants/product.constant';

export const generateEmailTemplateList = (emailTemplatesV2, productIds = new Set([-1])) => {
  const { api: { data = IEmailTemplateWithProductId() } } = emailTemplatesV2;
  let _templates = IEmailTemplateWithProductId().templateList;
  _templates = [];
  _templates = data.filter(({ productId }) => productIds.has(productId)).flatMap(({ templateList }) => templateList);

  let _uniqueTemplates = IEmailTemplateWithProductId().templateList;
  _uniqueTemplates = [];

  const _uniqueTemplateName = new Set(['']);
  _uniqueTemplateName.delete('');

  let otherTemplates = IEmailTemplateWithProductId().templateList;
  otherTemplates = [];

  /**
   * @description Prioritize AlternateRx products before other products.
   */
  for (let i = 0; i < _templates.length; i++) {
    const _template = _templates[i];

    if (_template.pId !== ALTERNATE_RX_PRODUCT_VALUE) {
      otherTemplates.push(_template);
      continue;
    }

    if (_uniqueTemplateName.has(_template.name)) {
      continue;
    }

    _uniqueTemplateName.add(_template.name);
    _uniqueTemplates.push(_template);
  }

  /**
   * @description Traverse lesser templates.
   */
  for (let i = 0; i < otherTemplates.length; i++) {
    const _template = otherTemplates[i];

    if (_uniqueTemplateName.has(_template.name)) {
      continue;
    }

    _uniqueTemplateName.add(_template.name);
    _uniqueTemplates.push(_template);
  }

  let _sortedTemplates = IEmailTemplateWithProductId().templateList;
  _sortedTemplates = sort(_uniqueTemplates, 'name', Order.asc, ColumnType.string);

  return _sortedTemplates;
};

export const selectedProductIds = (productInfo = { Product: [] }) => {
  const _productIds = new Set([-1]);
  for (let i = 0; i < productInfo.Product.length; i++) {
    const _product = productInfo.Product[i];
    if (_product.checked) {
      _productIds.add(_product.ProductId);
    }
  }
  return _productIds;
};

export const convertIntoEmail = (message = '') => {
  if (!message?.length) {
    return '';
  }

  try {
    let _m = message;
    _m = _m.replace(/\n/gmi, '<br>');
    return _m;
  } catch(e) {

  }

  return '';
};

export const convertIntoReadableMessage = (message = '', token = { doctor: '' }) => {
  if (!message?.length) {
    return '';
  }

  try {
    let _m = message;
    _m = _m.replace(/(<html>|<\/html>|<head>|<\/head>|<title>|<\/title>|<body style="height: auto; min-height: auto;">|<\/body>|<p>|<\/p>|<b>|<\/b>|<ul>|<\/ul>|<li>|<i>|<\/i>|<\D*div\D*>|<\D*table\D*>|<!--\D*\d*\D*->)/gmi, '');
    _m = _m.replace(/<\/li>/gmi, '\n');
    _m = _m.replace(/(<br>|<br >|<br \/>)/gmi, '\n');
    _m = _m.replace(/(<br>|<br >|<br \/>)/gmi, '\n');
    _m = _m.replace(/<<DOCTOR>>/gmi, token.doctor);
    // _m = _m.replace(/\n+/gmi, '\n'); // leave the new lines as is.
    _m = _m.split('\n').map(item => item.trim()).join('\n');
    return _m;
  } catch (e) {

  }

  try {
    let _m = message;
    _m = _m.replace(/<<DOCTOR>>/gmi, token.doctor);
    return _m;
  } catch (e) {

  }

  return '';
};

export const convertIntoReadableMessageV2 = (message = '', token = { doctor: '' }) => {
  if (!message?.length) {
    return '';
  }

  try {
    let _m = message;
    _m = _m.replace(/(<html>|<\/html>|<head>|<\/head>|<title>|<\/title>|\n+|<!--\D*\d*\D*->)/gmi, '');
    _m = _m.replace(/&lt;/gmi, '<');
    _m = _m.replace(/&gt;/gmi, '>');
    _m = _m.replace(/&lt;&lt;DOCTOR&gt;&gt;/gmi, token.doctor);
    _m = _m.replace(/<<DOCTOR>>/gmi, token.doctor);
    return _m;
  } catch (e) {

  }

  try {
    let _m = message;
    _m = _m.replace(/&lt;&lt;DOCTOR&gt;&gt;/gmi, token.doctor);
    _m = _m.replace(/<<DOCTOR>>/gmi, token.doctor);
    return _m;
  } catch (e) {

  }

  return '';
};
